<div [style.display]="isLoading ? 'flex' : 'none'">
  <app-loading-spinner>
    <ng-content select="[loading]"></ng-content>
  </app-loading-spinner>
</div>

<div *ngIf="!isError"><ng-content select="[nodata]"></ng-content></div>

<div *ngIf="isError && !isLoading" class="text-danger text-center">
  <ng-content select="[error]"></ng-content>

  <button class="btn btn-outline-primary" (click)="reload()">
    Reload page
  </button>
</div>
